export class PdfMakeContentRow {
  text?: any;
  inline?: boolean;
  italics?: boolean;
  bold?: boolean;
  link?: string;
  color?: string;
  lineHeight?: number;
  style?: string;
  forceInsert?: boolean;
  margin?: any;
  orderedList?: boolean;
  unorderedList?: boolean;
  ul?: any[]; // add ul
  ol?: any[]; // add ol
}
